const ITEMS = [
  "FAST COMMUNICATION",
  "ALWAYS STOCKED",
  "SPOTLESS & CLEAN",
  "SMART COOLERS",
  "MODERN VENDING FOR A MODERN WORLD",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-16 font-mono text-sm tracking-[0.3em] text-slate-500 whitespace-nowrap">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-vortex-cyan/50" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-white/5 bg-vortex-surface/40 py-6"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
